<div class="flex-col flex-100 justify-start pt-0 pr-1 pl-1 pb-1" [@slideInOut]>
    <a *ngFor="let doc of fileList$|async" class="justify-start items-center mb-05" (click)="handleFileDownload(doc)">
        <mat-icon class="mr-05">file_present</mat-icon>
        <span>{{doc.name}}</span>
    </a>
</div>

